(function () {
  'use strict';

  if (window.innerWidth > 767) return;

  var MAX_WAIT = 10000;
  var POLL     = 300;
  var elapsed  = 0;

  var poller = setInterval(function () {
    elapsed += POLL;
    var wrapper = document.querySelector('.mcf-wrapper');
    if (wrapper) {
      clearInterval(poller);
      init(wrapper);
    } else if (elapsed >= MAX_WAIT) {
      clearInterval(poller);
    }
  }, POLL);

  function init(wrapper) {
    var clearWrapper = wrapper.querySelector('.mcf-clear-wrapper');
    var clearBtn     = wrapper.querySelector('.mcf-clear-btn');

    /* ── 1. Dropdown toggle ─────────────────────────────── */
    wrapper.querySelectorAll('.mcf-group').forEach(function (group) {
      var btn      = group.querySelector('.mcf-btn');
      var dropdown = group.querySelector('.mcf-dropdown');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = group.classList.contains('mcf-open');
        closeAllGroups();
        if (!isOpen) openGroup(group, btn, dropdown);
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) closeAllGroups();
    });

    window.addEventListener('scroll', closeAllGroups, { passive: true });

    /* ── 2. Item selection ──────────────────────────────── */
    wrapper.querySelectorAll('.mcf-dropdown').forEach(function (dropdown) {
      dropdown.querySelectorAll('.mcf-item').forEach(function (item) {
        item.addEventListener('click', function () {

          dropdown.querySelectorAll('.mcf-item').forEach(function (i) {
            i.classList.remove('mcf-active');
          });
          item.classList.add('mcf-active');

          var tagHandle = item.getAttribute('data-tag');

          var checkbox = document.querySelector(
            '#collection-filter-drawer .Collapsible__Content .Linklist .Linklist__Item input[data-tag="' + tagHandle + '"]'
          );

          if (checkbox) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            applyTagsWhenReady();
          }

          closeAllGroups();
          if (clearWrapper) clearWrapper.style.display = 'flex';
        });
      });
    });

    /* ── 3. Clear filter ────────────────────────────────── */
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        var resetBtn = document.querySelector('button.ButtonGroup__Item[data-action="reset-tags"]');
        if (resetBtn) resetBtn.click();

        wrapper.querySelectorAll('.mcf-item.mcf-active').forEach(function (el) {
          el.classList.remove('mcf-active');
        });

        if (clearWrapper) clearWrapper.style.display = 'none';
      });
    }

    /* ── 4. Empty-state reset button (AJAX-rendered) ────── */
    var mo = new MutationObserver(function () {
      var emptyBtn = document.querySelector('button.EmptyState__Action');
      if (emptyBtn && !emptyBtn._mcfBound) {
        emptyBtn._mcfBound = true;
        emptyBtn.addEventListener('click', function () {
          wrapper.querySelectorAll('.mcf-item.mcf-active').forEach(function (el) {
            el.classList.remove('mcf-active');
          });
          if (clearWrapper) clearWrapper.style.display = 'none';
        });
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    /* ── 5. Sync active state from URL on load ──────────── */
    try {
      var tagSegment = window.location.pathname.split('/').slice(3).join('/');
      if (tagSegment) {
        var activeTags = tagSegment.split('+');
        var anyActive  = false;
        wrapper.querySelectorAll('.mcf-item').forEach(function (item) {
          if (activeTags.indexOf(item.getAttribute('data-tag')) !== -1) {
            item.classList.add('mcf-active');
            anyActive = true;
          }
        });
        if (anyActive && clearWrapper) clearWrapper.style.display = 'flex';
      }
    } catch (e) {}
  }

  /**
   * Instead of a fixed 1200ms wait, poll until the Apply button is
   * enabled and the drawer checkbox state has settled, then click immediately.
   * Falls back to 600ms if the button never becomes ready.
   */
  function applyTagsWhenReady() {
    var applyBtn = document.querySelector('button.ButtonGroup__Item[data-action="apply-tags"]');
    if (!applyBtn) return;

    var READY_POLL    = 50;   /* check every 50ms   */
    var READY_TIMEOUT = 600;  /* fallback after 600ms */
    var waited        = 0;

    /* If the theme disables the button while processing, wait for it
       to become enabled again before clicking.                        */
    var readyPoller = setInterval(function () {
      waited += READY_POLL;

      var isDisabled = applyBtn.disabled || applyBtn.getAttribute('aria-disabled') === 'true';

      if (!isDisabled || waited >= READY_TIMEOUT) {
        clearInterval(readyPoller);
        applyBtn.click();
      }
    }, READY_POLL);
  }

  /* ── Helpers ────────────────────────────────────────────── */
  function openGroup(group, btn, dropdown) {
    group.classList.add('mcf-open');
    btn.setAttribute('aria-expanded', 'true');
    dropdown.removeAttribute('hidden');
  }

  function closeGroup(group) {
    var btn      = group.querySelector('.mcf-btn');
    var dropdown = group.querySelector('.mcf-dropdown');
    group.classList.remove('mcf-open');
    if (btn)      btn.setAttribute('aria-expanded', 'false');
    if (dropdown) dropdown.setAttribute('hidden', '');
  }

  function closeAllGroups() {
    document.querySelectorAll('.mcf-group.mcf-open').forEach(closeGroup);
  }

}());